export class ExpressTestByRequestDto {
    customerObjectId: number;
    performerUserId: number;
    performerUserName: string;
    requestId: number;
    requestTypeId: number;
    completeDate: string;
    laboratoryRequestIndicators: ExpressTestRequestIndicatorDto[] = [];

    id: string;
    completeDateValue: Date;
}

export class ExpressTestRequestIndicatorDto {
    laboratoryRequestIndicatorId: number;
    laboratoryIndicatorId: number;
    name: string;
    laboratoryIndicatorCode: string;
    postHandleValue: number;
    value: number;
}